(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if (this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-reviews"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function(){
  $('body').on('click', '.slider-tab-item button', function(e){
    e.preventDefault();
    $(this).parents('.cc-featured-review').find('.slider-tab-item button').removeClass('active-tab');
    if ($(this).parents('.cc-featured-review').find('carousel-slider').length > 0 
        ? $(this).parents('.cc-featured-review').find('carousel-slider').hide() 
        : $(this).parents('.cc-featured-review').find('.products-grid-container').hide());

    let currentTab = $(this).attr('id');
    $(this).addClass('active-tab');
    if ($(this).parents('.cc-featured-review').find('carousel-slider[data-tab-id="'+ currentTab +'"]').length > 0 
        ? $(this).parents('.cc-featured-review').find('carousel-slider[data-tab-id="'+ currentTab +'"]').show() 
        : $(this).parents('.cc-featured-review').find('.products-grid-container[data-tab-id="'+ currentTab +'"]').show());
  });
  $(document).on('click', '.featured-review-link-scroll', function(e) {
    e.preventDefault();    
    var id = $(this).data('review-block'), $id = $(id);
    if ($id.length === 0) { 
      if (document.querySelector('.yotpo-sr-bottom-line-summary')){
        let event = new Event("click");
        document.querySelector('.yotpo-sr-bottom-line-summary').dispatchEvent(event);
      }
      return; 
    }
    var pos = $id.offset().top - $('.header').outerHeight();
    $('body, html').animate({scrollTop: pos});
  });
});

  } catch(e) { console.error(e); }
})();
})();
